import Process from "./basic_production/index.js";

export default [...Process];
